export default __webpack_public_path__ + "static/media/cart.eb73a602.svg";